import { store } from "./store";

export function dispatchMultipleActions(...actions) {
  actions.forEach(action => store.dispatch(action));
}
